import React, {useEffect, useState} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import {Dropdown, Space} from "antd";
import {useTranslation} from "react-i18next";
import {ConfigKeyword} from "./ConfigKeyword";

const FilterTimeSheet = ({title}) => {

    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const tabKey = searchParams.get("tabKey")
    const {t} = useTranslation()
    const tabItems = [
        {
            key: ConfigKeyword.SHIFT_KEYWORD,
            label: t("tabFormula.SHIFT_KEYWORD"),
        },
        {
            key: ConfigKeyword.KEYWORD,
            label: t("tabFormula.KEYWORD"),
        },
        {
            key: ConfigKeyword.DATE_KEYWORD,
            label: t("tabFormula.DATE_KEYWORD"),
        },

        {
            key: ConfigKeyword.OVERTIME_KEYWORD,
            label: t("tabFormula.OVERTIME_KEYWORD"),
        },
        {
            key: ConfigKeyword.MISSION_KEYWORD,
            label: t("tabFormula.MISSION_KEYWORD"),

        },

        {
            key: ConfigKeyword.HOURLY_LEAVE_KEYWORD,
            label: t("tabFormula.HOURLY_LEAVE_KEYWORD"),

        },

        {
            key: ConfigKeyword.MONTHLY_APPLICATION_KEYWORD,
            label: t("tabFormula.MONTHLY_APPLICATION_KEYWORD"),

        },

        {
            key: ConfigKeyword.CHECK_INOUT_KEYWORD,
            label: t("tabFormula.CHECK_IN/OUT_KEYWORD"),

        },

    ]

    const [filterData, setFilterData] = useState(tabItems)

    useEffect(() => {
        setFilterData(filterData?.map(item => {

            const disabled = !tabKey && item.key === "deleteAllSelection"

            if (item.key === "deleteAllSelection") {
                item.label = <span style={{color: !disabled ? "var(--primary-color)" : "#98A2B3"}}>
                    {t("tnp.components.timekeeping.text53")}
                </span>
            }

            return {
                ...item,
                disabled
            }
        }))
    }, [tabKey])

    const onChangeTab = (tab) => {
        const key = tab.key

        if (key === "deleteAllSelection") {

            searchParams.delete("tabKey")

            navigate(`?${searchParams.toString()}`)
        } else {
            searchParams.set("tabKey", tab.key);

            navigate(`?${searchParams.toString()}`)
        }

        setDropdownOpen(false)

    }

    function removeKey() {
        searchParams.delete("tabKey")

        navigate(`?${searchParams.toString()}`)
    }

    return (

        <Space align={"center"} className={"cursor-pointer"}>

        <span
            onClick={() => !!tabKey ? removeKey() : setDropdownOpen(true)}
            style={{
                color: tabKey ? "#1890FF" : "#101828"
            }}
            className={"font-semibold text-lg"}
        >{title || t("common.application")} </span>

            <Dropdown
                menu={{
                    items: filterData,
                    onClick: onChangeTab,
                    selectedKeys: tabKey,
                    trigger: ["click"],
                    className: "extraMenuFilter",
                }}
                trigger={["click"]}
                placement={"bottomLeft"}
                open={dropdownOpen}
                onOpenChange={setDropdownOpen}
            >
                <Space size={8} align={"center"}>
                    {tabKey && (
                        <span className={"text-base text-[#101828] font-semibold"}>/ {tabItems.find(item => item.key === tabKey)?.label}
                        </span>)}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" style={{marginTop: 2}}>
                        <path d="M5 10H15M2.5 5H17.5M7.5 15H12.5" stroke="var(--primary-color)" strokeWidth="1.66667"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </Space>

            </Dropdown>

        </Space>
    );

};

FilterTimeSheet.propTypes = {};

export default FilterTimeSheet;